import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { setAuthenticated } from '../../store/slices/userSlice';
import { checkSessionExpiration } from '../../util';
import Message from '../message/message';
import Confirmation from '../message/confirmation';
import { rowSpanningStateInitializer } from '@mui/x-data-grid/internals';
import { renewSession } from '../../services/securityService';
import { enqueueSnackbar } from 'notistack';
import { showWaiting } from '../../store/slices/configSlice';


const SessionTimeoutHandler = () => {
    const [open, setOpen] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [resultConfirmation, setResultConfirmation] = useState(false);
    const dispatch = useDispatch();
    const { userLogged } = useSelector(state => state.userLogged);
    const navigate = useNavigate();
    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    const onCloseExpirationMessage = () => {
        dispatch(setAuthenticated(null))
        
        try{
            const ventanaLogout = window.open(
                'https://accounts.google.com/logout',
                '_blank',
                'width=10,height=10,top=-1000,left=-1000'
            );

            setTimeout(() => {
                if (ventanaLogout && !ventanaLogout.closed) {
                    ventanaLogout.close();
                }
                navigate("/");
            }, 800);
        }
        catch(e){
            const iframe = document.createElement('iframe');
            iframe.src = 'https://accounts.google.com/logout';
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
        }
        
    }


    const onCloseConfirmation = () => {
        setOpenConfirmation(false);
    }

    const onConfirmation = (response) => {
        if (response){
            dispatch(showWaiting(true));
            renewSession(userLogged.userId)
                .then((rsp) => {
                    if (rsp.code === '00'){
                        setTimeout(() => {
                            dispatch(setAuthenticated(rsp.metadata.token))
                            enqueueSnackbar(rsp.message, { variant: 'success', persist: false });
                            dispatch(showWaiting(false));
                        }, 1500); 
                    }
                    else{
                        setTimeout(() => {
                            enqueueSnackbar(rsp.message, { variant: 'success', persist: false });
                            dispatch(showWaiting(false));
                        }, 500); 
                    }
                });
        }
    }


    useEffect(() => {
        if (!userLogged?.expiration) return;

        const checkExpiration = () => {
            if (checkSessionExpiration(userLogged.expiration)) {
                setOpen(true);
            }
            else{
                const differenceInMs = new Date(userLogged.expiration) - new Date();
                const differenceInMinutes = Math.floor(differenceInMs / (1000 * 60)); 
                if (differenceInMinutes <= 3)
                    setOpenConfirmation(true);
            }
        };

        // Verificar inmediatamente al montar el componente
        checkExpiration();

        // Verificar cada minuto (ajusta según necesites)
        const interval = setInterval(checkExpiration, 60000);

        return () => clearInterval(interval);
    }, [dispatch, userLogged?.expiration]);

    return (
        <>
            <Message 
                title={t("sessionTimeoutHandler.messageTitle")} 
                content={t("sessionTimeoutHandler.messageContent")} 
                open={open} 
                onClose={()=>onCloseExpirationMessage()} />

            <Confirmation 
                title={t("sessionTimeoutHandler.confirmationTitle")} 
                content={t("sessionTimeoutHandler.confirmationContent")}  
                open={openConfirmation} 
                onClose={onCloseConfirmation}
                onResponse={(response)=>onConfirmation(response)}
            />
        </>
    );
};

export default SessionTimeoutHandler; 